// Shared breakpoint values for mobile/tablet layout rules. No CSS
// preprocessor is configured (no PostCSS/Sass @custom-media support), so
// CSS Modules cannot reference these directly — files that need them write
// the literal `@media (max-width: ${MOBILE_BP}px)` value themselves, with a
// `/* keep in sync with src/styles/breakpoints.js */` comment. This file is
// the source of truth for JS consumers (e.g. useIsMobile).
export const MOBILE_BP = 600
export const TABLET_BP = 900
